import * as React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const galleryItems = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/auto_care_rim_polishing_detail.png",
  alt: "Modern social housing apartment in London showing high-quality finish",
  city: "London"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/property_care_driveway_pressure_wash.png",
  alt: "High-yield residential complex in Cambridge with government-backed security",
  city: "Cambridge"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/auto_care_ceramic_coating_finish.png",
  alt: "Government-backed investment property in Oxford offering long-term stability",
  city: "Oxford"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/property_care_roof_tile_cleaning.png",
  alt: "Secure social housing income asset in Bristol with FRI lease terms",
  city: "Bristol"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/auto_care_interior_leather_treatment.png",
  alt: "Newly refurbished social impact housing in Brighton for long-term tenants",
  city: "Brighton"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/property_care_exterior_window_cleaning.png",
  alt: "Professionally managed investment property in Southampton with CPI-linked returns",
  city: "Southampton"
}];
export default function OurWorkInFrames() {
  return <section data-section-id="72240" id="asset-showcase" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 flex items-end justify-between gap-4">
          <div>
            <h2 className="text-4xl font-bold tracking-tighter text-foreground sm:text-5xl font-default">
              Strategic Asset Portfolio
            </h2>
            <p className="mt-2 text-lg text-muted-foreground font-default">
              High-yield social housing investments secured by long-term government-backed leases.
            </p>
          </div>
          <Button variant="link" className="hidden h-auto p-0 text-primary sm:inline-flex font-default" asChild>
            
          </Button>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-6">
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="group relative overflow-hidden rounded-xl bg-card shadow-lg">
              <AspectRatio ratio={1}>
                <img src={item.src} alt={item.alt} className="h-full w-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110" />
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-secondary/0 transition-colors duration-500 group-hover:bg-secondary/80 backdrop-blur-sm">
                  <span className="translate-y-4 text-xl font-bold text-primary opacity-0 transition-all duration-300 ease-out group-hover:translate-y-0 group-hover:opacity-100 font-default">
                    Yield: 10.1%
                  </span>
                  <span className="translate-y-4 text-sm font-medium text-primary/90 opacity-0 transition-all duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100 font-default">
                    {item.city}
                  </span>
                </div>
              </AspectRatio>
            </div>)}
        </div>

        <div className="mt-8 flex justify-center sm:hidden">
          <Button variant="link" className="h-auto p-0 text-primary font-default" asChild>
            <Link to="#">View Asset Portfolio</Link>
          </Button>
        </div>
      </div>
    </section>;
}